import {registerPlugin} from '@capacitor/core'

/**
 * The bridge handle for the local `NativeSecureStoragePlugin` (#1691) —
 * Keychain-backed on iOS (`ios/App/CapApp-SPM/Sources/CapApp-SPM/
 * NativeSecureStoragePlugin.swift`), Keystore-backed on Android
 * (`android/.../NativeSecureStoragePlugin.java`). Not an npm package — a
 * plugin whose native source lives directly in this repo's `ios/`/`android/`
 * projects, registered the way Capacitor's own docs describe for
 * app-local/custom native code, not `capacitor.config.ts`.
 *
 * Shared by both `authStorage.js` (session/refresh token) and
 * `deviceIdentity.js` (the NATIVE_DEVICE id) — one plugin handle instead of
 * two, since both are just "one Keychain/Keystore key/value pair,
 * async get/set/remove."
 *
 * `registerPlugin` itself is safe to call even on web (Capacitor's own
 * `registerPlugin` falls back to a web implementation or a no-op stub when
 * none is registered) — but nothing in this codebase calls into the
 * returned methods unless `isNativePlatform()` was already checked, exactly
 * like every other adapter in this directory.
 */
export const NativeSecureStorage = registerPlugin('NativeSecureStorage')
